/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Last_UpdatedInputs */

const es_privacy_policy_last_updated = /** @type {(inputs: Privacy_Policy_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultima actualizacion: 16 de marzo de 2026 · Version 1.0`)
};

const en_privacy_policy_last_updated = /** @type {(inputs: Privacy_Policy_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last updated: March 16, 2026 · Version 1.0`)
};

/**
* | output |
* | --- |
* | "Last updated: March 16, 2026 · Version 1.0" |
*
* @param {Privacy_Policy_Last_UpdatedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_last_updated = /** @type {((inputs?: Privacy_Policy_Last_UpdatedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Last_UpdatedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_last_updated(inputs)
	return en_privacy_policy_last_updated(inputs)
});
export { privacy_policy_last_updated as "privacy_policy.last_updated" }